// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KU0pu","inner":"styles_inner__2HHa0","right":"styles_right__2R6yc","close":"styles_close__30J4p","footer":"styles_footer__3_w5V"};